import { CAR_TYPES } from 'site-modules/shared/constants/upper-funnel/car-types';

export const NAV_SUV_LIST = [
  { name: 'Hybrid SUVs', hash: 'hybrid' },
  { name: 'Electric SUVs', hash: 'electric' },
  { name: 'Luxury SUVs', hash: 'luxury' },
  { name: '3-Row SUVs', hash: '3-row' },
];

const TYPE_DISPLAY_MAPPING = {
  [CAR_TYPES.SUV]: 'SUV',
  [CAR_TYPES.TRUCK]: 'Truck',
  [CAR_TYPES.SEDAN]: 'Sedan',
  [CAR_TYPES.ELECTRIC]: 'Electric Car',
  [CAR_TYPES.HYBRID]: 'Hybrid',
};

const getArticleLink = type => ({
  name: `All ${TYPE_DISPLAY_MAPPING[type]} Articles`,
  hash: `articles`,
});

export const TYPE_NAVIGATION_LIST = {
  [CAR_TYPES.SUV]: [...NAV_SUV_LIST, getArticleLink(CAR_TYPES.SUV)],
  [CAR_TYPES.TRUCK]: [getArticleLink(CAR_TYPES.TRUCK)],
  [CAR_TYPES.SEDAN]: [getArticleLink(CAR_TYPES.SEDAN)],
  [CAR_TYPES.ELECTRIC]: [getArticleLink(CAR_TYPES.ELECTRIC)],
  [CAR_TYPES.HYBRID]: [getArticleLink(CAR_TYPES.HYBRID)],
};
